<template>
  <div>
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="基本信息">
          <div>
            <div class="info-main">
                <div class="input-box">
                    <p>所在部门：</p>
                    <a-input v-model="baseInfo.orgName" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>姓名：</p>
                    <a-input v-model="baseInfo.teacherName" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>工号：</p>
                    <a-input v-model="baseInfo.teacherId" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>证件号码：</p>
                    <a-input v-model="baseInfo.identityNumber" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>出生年月：</p>
                    <a-input v-model="baseInfo.birthday" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>专业方向：</p>
                    <a-input v-model="baseInfo.majorField" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>合作导师姓名：</p>
                    <a-input v-model="baseInfo.mentorTeacherName" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>导师工号：</p>
                    <a-input v-model="baseInfo.mentorTeacherId" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>所在二级专业：</p>
                    <a-input v-model="baseInfo.majorLevel2" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>进站时间：</p>
                    <a-input v-model="baseInfo.inboudDate" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>出站时间：</p>
                    <a-input v-model="baseInfo.outboudDate" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>退站时间：</p>
                    <a-input v-model="baseInfo.exitDate" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>入学方式：</p>
                    <a-input v-model="baseInfo.enrollmentModel" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>博士毕业学校：</p>
                    <a-input v-model="baseInfo.doctoralSchool" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>硕士毕业学校：</p>
                    <a-input v-model="baseInfo.masterSchool" class="input" disabled/>
                </div>
                <div class="input-box">
                    <p>本科毕业学校：</p>
                    <a-input v-model="baseInfo.undergraduateSchool" class="input" disabled/>
                </div>
            </div>
          </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="发表论文" force-render>
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysPaper[0]==null||selectedRowKeysPaper.length>1)?selectedCheck():$refs.paper.showDrawer('查看',doctorId,selectedRowKeysPaper[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.paper.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysPaper[0]==null||selectedRowKeysPaper.length>1)?selectedCheck():$refs.paper.showDrawer('编辑',doctorId,selectedRowKeysPaper[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysPaper[0] == null || selectedRowKeysPaper.length > 1) ? selectedCheck() :remove(selectedRowKeysPaper[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check"
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="paperColumns" 
            :data-source="paperData" 
            :customRow="onClickRowPaper"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysPaper, onChange: onSelectChangePaper }"
            bordered>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="3" tab="科研项目">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysResearch[0]==null||selectedRowKeysResearch.length>1)?selectedCheck():$refs.research.showDrawer('查看',doctorId,selectedRowKeysResearch[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.research.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysResearch[0]==null||selectedRowKeysResearch.length>1)?selectedCheck():$refs.research.showDrawer('编辑',doctorId,selectedRowKeysResearch[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysResearch[0] == null || selectedRowKeysResearch.length > 1) ? selectedCheck() :remove(selectedRowKeysResearch[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="researchColumns" 
            :data-source="researchData" 
            :customRow="onClickRowResearch"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysResearch, onChange: onSelectChangeResearch }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="4" tab="专利">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysPatent[0]==null||selectedRowKeysPatent.length>1)?selectedCheck():$refs.patent.showDrawer('查看',doctorId,selectedRowKeysPatent[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.patent.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysPatent[0]==null||selectedRowKeysPatent.length>1)?selectedCheck():$refs.patent.showDrawer('编辑',doctorId,selectedRowKeysPatent[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysPatent[0] == null || selectedRowKeysPatent.length > 1) ? selectedCheck() :remove(selectedRowKeysPatent[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="patentColumns" 
            :data-source="patentData" 
            :customRow="onClickRowPatent"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysPatent, onChange: onSelectChangePatent }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="5" tab="专著">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysMonograph[0]==null||selectedRowKeysMonograph.length>1)?selectedCheck():$refs.monograph.showDrawer('查看',doctorId,selectedRowKeysMonograph[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.monograph.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysMonograph[0]==null||selectedRowKeysMonograph.length>1)?selectedCheck():$refs.monograph.showDrawer('编辑',doctorId,selectedRowKeysMonograph[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysMonograph[0] == null || selectedRowKeysMonograph.length > 1) ? selectedCheck() :remove(selectedRowKeysMonograph[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="monographColumns" 
            :data-source="monographData" 
            :customRow="onClickRowMonograph"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysMonograph, onChange: onSelectChangeMonograph }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="6" tab="基金">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysFund[0]==null||selectedRowKeysFund.length>1)?selectedCheck():$refs.fund.showDrawer('查看',doctorId,selectedRowKeysFund[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.fund.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysFund[0]==null||selectedRowKeysFund.length>1)?selectedCheck():$refs.fund.showDrawer('编辑',doctorId,selectedRowKeysFund[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysFund[0] == null || selectedRowKeysFund.length > 1) ? selectedCheck() :remove(selectedRowKeysFund[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="fundColumns" 
            :data-source="fundData" 
            :customRow="onClickRowFund"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysFund, onChange: onSelectChangeFund }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="7" tab="奖励">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysReward[0]==null||selectedRowKeysReward.length>1)?selectedCheck():$refs.reward.showDrawer('查看',doctorId,selectedRowKeysPaper[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.reward.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysReward[0]==null||selectedRowKeysReward.length>1)?selectedCheck():$refs.reward.showDrawer('编辑',doctorId,selectedRowKeysReward[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysReward[0] == null || selectedRowKeysReward.length > 1) ? selectedCheck() :remove(selectedRowKeysReward[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="rewardColumns" 
            :data-source="rewardData" 
            :customRow="onClickRowReward"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysReward, onChange: onSelectChangeReward }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="8" tab="学术交流">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysAcademic[0]==null||selectedRowKeysAcademic.length>1)?selectedCheck():$refs.academic.showDrawer('查看',doctorId,selectedRowKeysAcademic[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.academic.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysAcademic[0]==null||selectedRowKeysAcademic.length>1)?selectedCheck():$refs.academic.showDrawer('编辑',doctorId,selectedRowKeysAcademic[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysAcademic[0] == null || selectedRowKeysAcademic.length > 1) ? selectedCheck() :remove(selectedRowKeysAcademic[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="academicColumns" 
            :data-source="academicData" 
            :customRow="onClickRowAcademic"
            :pagination="false"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysAcademic, onChange: onSelectChangeAcademic }"
            bordered>
        </a-table>
        
      </a-tab-pane>
      <a-tab-pane key="9" tab="社会影响">
        <div class="operation-box">
            <a-button
                type="primary"
                icon="file-search" 
                class="btn"
                @click="(selectedRowKeysSocial[0]==null||selectedRowKeysSocial.length>1)?selectedCheck():$refs.social.showDrawer('查看',doctorId,selectedRowKeysSocial[0])"
                >
                 查看
            </a-button>
            <a-button
                type="primary"
                icon="plus" 
                class="btn" 
                v-if="permissions.indexOf('hr:doctor:research:add')>-1"
                @click="$refs.social.showDrawer('新增',doctorId,'')"
                >
                 新增
            </a-button>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:edit')>-1"
                @click="(selectedRowKeysSocial[0]==null||selectedRowKeysSocial.length>1)?selectedCheck():$refs.social.showDrawer('编辑',doctorId,selectedRowKeysSocial[0])"                
                >
                 编辑
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="(selectedRowKeysSocial[0] == null || selectedRowKeysSocial.length > 1) ? selectedCheck() :remove(selectedRowKeysSocial[0])">
                <a-button
                    v-if="permissions.indexOf('hr:doctor:research:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button
                type="primary"
                icon="check" 
                class="btn"
                v-if="permissions.indexOf('hr:doctor:research:approve')>-1"
                @click="showModel"
                >
                 审核
            </a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="socialColumns" 
            :data-source="socialData" 
            :customRow="onClickRowSocial"
            :pagination="false"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeysSocial, onChange: onSelectChangeSocial}"
            bordered>
        </a-table>
        
      </a-tab-pane>
    </a-tabs>
    <paper ref="paper"></paper>
    <research ref="research"></research>
    <patent ref="patent"></patent>
    <monograph ref="monograph"></monograph>
    <fund ref="fund"></fund>
    <reward ref="reward"></reward>
    <academic ref="academic"></academic>
    <social ref="social"></social>
    <div>
        <a-modal v-model="visible" title="审核意见" on-ok="handleOk">
        <template slot="footer">
            <a-button key="back" @click="handleOk('')">
            取消
            </a-button>
            <a-button key="submit" type='danger' :loading="loading" @click="handleOk('reject')">
            驳回
            </a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk('approved')">
            通过
            </a-button>
        </template>
            <a-textarea
                class="input-box"
                v-model="approveBody.approvalComments"
                :auto-size="{ minRows: 3, maxRows: 5 }"
            />
        </a-modal>
    </div>
    <div class="btn-box">
        <a-button @click="$router.go(-1)">取消</a-button>
    </div>
  </div>
  
</template>
<script>
// social
// reward
// academic
// fund
// monograph
// paper
// patent
// research
import { getTeacher} from '@/baseAPI/facultyTeacher'
import { selectedCheck } from '@/baseAPI/util'
import { getPaper,check,getSocial,getReward,getAcademic,getFund,getMonograph,getPatent,getResearch,del } from '@/baseAPI/postdoctor'
import Paper from './modules/postdoctorPaper'
import Social from './modules/postdoctorSocial'
import Reward from './modules/postdoctorReward'
import Academic from './modules/postdoctorAcademic'
import Fund from './modules/postdoctorFund'
import Monograph from './modules/postdoctorMonograph'
import Patent from './modules/postdoctorPatent'
import Research from './modules/postdoctorResearch'
import { queryDepartmentTreeList } from '@/baseAPI/department'

export default {
   components: {
        Paper,Social,Reward,Academic,Fund,Monograph,Patent,Research
  },
  data() {
    return {
        id:'',
        doctorId:'',
        baseInfo:{

        },
        paperColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '发表或录用日期',
                dataIndex: 'publishDate',
                align:'center',
                width:150,
            },
            {
                title: '发表类别',
                dataIndex: 'publishCategory',
                align:'center',
                width:120,
            },
            {
                title: '最高分区',
                dataIndex: 'highestPartition',
                align:'center',
                width:120,
            },
            {
                title: '本人排名',
                dataIndex: 'selfRanking',
                align:'center',
                width:120,
            },
            {
                title: '上海大学是否第一作者单位',
                dataIndex: 'isIrshuFirstAuthorUnit',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    return text ? '是' : '否';
                },
            },
            {
                title: '图书馆审核状态',
                dataIndex: 'libraryReviewStatus',
                align:'center',
                width:120,
            },
            {
                title: '检索类型',
                dataIndex: 'searchType',
                align:'center',
                width:120,
            },
            {
                title: '期刊类型',
                dataIndex: 'journalType',
                align:'center',
                width:120,
            },
            {
                title: '论文题目（中文）',
                dataIndex: 'paperTitleChinese',
                align:'center',
                width:120,
            },
            {
                title: '论文题目_英文',
                dataIndex: 'paperTitleEnglish',
                align:'center',
                width:120,
            },
            {
                title: '期刊名称',
                dataIndex: 'journalName',
                align:'center',
                width:120,
            },
            {
                title: '论文发表的学术刊物或会议名称',
                dataIndex: 'thesisName',
                align:'center',
                width:120,
            },
            {
                title: '期刊号',
                dataIndex: 'journalNumber',
                align:'center',
                width:120,
            },
            {
                title: '年卷期',
                dataIndex: 'annualVolumePeriod',
                align:'center',
                width:120,
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        paperData:[],
        selectedRowKeysPaper:[],

        socialColumns:[
            {
                title: '序号',
                align:'center',
                width:10,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '社会影响',
                dataIndex: 'impactOutcome',
                align:'center',
                width:500
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        socialData:[],
        selectedRowKeysSocial:[],

        rewardColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '奖励名称',
                dataIndex: 'rewardName',
                align:'center',
                width:120
            },
            {
                title: '获奖类型名称',
                dataIndex: 'rewardType',
                align:'center',
                width:120
            },
            {
                title: '获奖年份',
                dataIndex: 'year',
                align:'center',
                width:120
            },
            {
                title: '获奖月份',
                dataIndex: 'month',
                align:'center',
                width:120
            },
            {
                title: '排名',
                dataIndex: 'sortNmuber',
                align:'center',
                width:120
            },
            {
                title: '等级',
                dataIndex: 'level',
                align:'center',
                width:120
            },
            {
                title: '报告题目',
                dataIndex: 'reportTitle',
                align:'center',
                width:120
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        rewardData:[],
        selectedRowKeysReward:[],

        academicColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '参加国际交流',
                dataIndex: 'isInternational',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    return text ? '是' : '否';
                },
            },
            {
                title: '时间',
                dataIndex: 'academicExchangeDate',
                align:'center',
                width:120
            },
            {
                title: '名称',
                dataIndex: 'academicExchangeName',
                align:'center',
                width:120
            },
            {
                title: '摘要',
                dataIndex: 'academicExchangeAbstract',
                align:'center',
                width:120
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        academicData:[],
        selectedRowKeysAcademic:[],

        fundColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '基金名称',
                dataIndex: 'fundName',
                align:'center',
                width:120
            },
            {
                title: '基金级别名称',
                dataIndex: 'fundLevelName',
                align:'center',
                width:120
            },
            {
                title: '基金金额',
                dataIndex: 'fundAmount',
                align:'center',
                width:120
            },
            {
                title: '项目名称',
                dataIndex: 'projectName',
                align:'center',
                width:120
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        fundData:[],
        selectedRowKeysFund:[],

        monographColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '专著名称',
                dataIndex: 'monographName',
                align:'center',
                width:120
            },
            {
                title: '书号',
                dataIndex: 'bookNumber',
                align:'center',
                width:120
            },
            {
                title: '专著出版社',
                dataIndex: 'monographPress',
                align:'center',
                width:120
            },
            {
                title: '专著出版日期',
                dataIndex: 'publishDate',
                align:'center',
                width:150
            },
            {
                title: '论著方式',
                dataIndex: 'monographType',
                align:'center',
                width:120
            },
            {
                title: '作者排名',
                dataIndex: 'authorRank',
                align:'center',
                width:120
            },
            {
                title: '申获基金名称',
                dataIndex: 'fundName',
                align:'center',
                width:120
            },
            {
                title: '申请时间',
                dataIndex: 'applyDate',
                align:'center',
                width:150
            },
            {
                title: '项目批准号',
                dataIndex: 'approveNumber',
                align:'center',
                width:120
            },
            {
                title: '批准时间',
                dataIndex: 'approveDate',
                align:'center',
                width:150
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        monographData:[],
        selectedRowKeysMonograph:[],

        patentColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '专利名称',
                dataIndex: 'patentName',
                align:'center',
                width:120
            },
            {
                title: '专利类型名称',
                dataIndex: 'patentType',
                align:'center',
                width:120
            },
            {
                title: '受理或授权时间',
                dataIndex: 'acceptDate',
                align:'center',
                width:120
            },
            {
                title: '申请或专利号',
                dataIndex: 'patentNumber',
                align:'center',
                width:120
            },
            {
                title: '公开号',
                dataIndex: 'publishNumber',
                align:'center',
                width:120
            },
            {
                title: '排名',
                dataIndex: 'sortNumber',
                align:'center',
                width:120
            },
            {
                title: '专利批准国',
                dataIndex: 'approvalCountry',
                align:'center',
                width:120
            },
            {
                title: '专利简介',
                dataIndex: 'patentDescribe',
                align:'center',
                width:120
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        patentData:[],
        selectedRowKeysPatent:[],

        researchColumns:[
            {
                title: '序号',
                align:'center',
                width:70,
                customRender: (text, row, index) => {
                    return { children: index+1};
                },
            },
            {
                title: '审核状态',
                dataIndex: 'approvalStatus',
                align:'center',
                width:120,
                customRender: (text, row, index) => {
                    if(text == 'draft'){
                        return '草稿'
                    }else if(text == 'approved'){
                        return '已审核'
                    }else if(text == 'reject'){
                        return '已驳回'
                    }else if(text == 'commit'){
                        return '已提交'
                    }
                    return text;
                },
            },
            {
                title: '项目名称',
                dataIndex: 'projectName',
                align:'center',
                width:120
            },
            {
                title: '项目金额',
                dataIndex: 'projectAmount',
                align:'center',
                width:120
            },
            {
                title: '批准时间',
                dataIndex: 'approveDate',
                align:'center',
                width:120
            },
            {
                title: '下达部门',
                dataIndex: 'issuingDept',
                align:'center',
                width:120
            },
            {
                title: '项目性质名称',
                dataIndex: 'projectNature',
                align:'center',
                width:120
            },
            {
                title: '进展情况名称',
                dataIndex: 'projectProgress',
                align:'center',
                width:120
            },
            {
                title: '承担责任名称',
                dataIndex: 'responsibleName',
                align:'center',
                width:120
            },
            {
                title: '审核意见',
                dataIndex: 'approvalComments',
                align:'center',
                width:200
            },
        ],
        researchData:[],
        selectedRowKeysResearch:[],

        approveBody:{
            ids:[],
            approvalComments:''
        },
        visible: false,
        loading: false,
        permissions:[],
        departmentTree:[]
    };
  },
  mounted(){
        this.doctorId=this.$route.query.id;
        queryDepartmentTreeList().then(res => {
            this.departmentTree = res.data[0].children
            this.info(this.doctorId);
        })
        
        this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
        
  },
  methods: {
        remove(id){
            del(this.reward,id).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'删除成功',
                    });
                    if(this.reward=='paper'){
                        this.getPaper()
                    }else if(this.reward=='researchProject'){
                        this.getResearch()
                    }else if(this.reward=='patent'){
                        this.getPatent()
                    }else if(this.reward=='monograph'){
                        this.getMonograph()
                    }else if(this.reward=='fund'){
                        this.getFund()
                    }else if(this.reward=='reward'){
                        this.getReward()
                    }else if(this.reward=='academicExchange'){
                        this.getAcademic()
                    }else if(this.reward=='socialInfluence'){
                        this.getSocial()
                    }
                }else{
                    this.$notification['error']({
                        message: '删除失败',
                        description:res.data.errorMessage,
                    });
                }
            })
        },
        selectedCheck(){
            selectedCheck()
        },
        showModel(){
            this.visible = true;
        },
        handleOk(approvalStatus) {
            if(approvalStatus!=''){
                this.loading = true;
                if(this.reward=='paper'){
                    this.approveBody.ids=this.selectedRowKeysPaper
                }else if(this.reward=='researchProject'){
                    this.approveBody.ids=this.selectedRowKeysResearch
                }else if(this.reward=='patent'){
                    this.approveBody.ids=this.selectedRowKeysPatent
                }else if(this.reward=='monograph'){
                    this.approveBody.ids=this.selectedRowKeysMonograph
                }else if(this.reward=='fund'){
                    this.approveBody.ids=this.selectedRowKeysFund
                }else if(this.reward=='reward'){
                    this.approveBody.ids=this.selectedRowKeysReward
                }else if(this.reward=='academicExchange'){
                    this.approveBody.ids=this.selectedRowKeysAcademic
                }else if(this.reward=='socialInfluence'){
                    this.approveBody.ids=this.selectedRowKeysSocial
                }
                check(this.reward,approvalStatus,this.approveBody).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:(approvalStatus=='approved'?'审批通过':'驳回成功'),
                        });
                        if(this.reward=='paper'){
                            this.getPaper()
                        }else if(this.reward=='researchProject'){
                            this.getResearch()
                        }else if(this.reward=='patent'){
                            this.getPatent()
                        }else if(this.reward=='monograph'){
                            this.getMonograph()
                        }else if(this.reward=='fund'){
                            this.getFund()
                        }else if(this.reward=='reward'){
                            this.getReward()
                        }else if(this.reward=='academicExchange'){
                            this.getAcademic()
                        }else if(this.reward=='socialInfluence'){
                            this.getSocial()
                        }
                    }else{
                        this.$notification['error']({
                            message: '审批失败',
                            description:res.data.errorMessage,
                        });
                    }
                    this.visible = false;
                    this.loading = false;
                })
            }else{
                this.visible = false;
            }
        },
        callback(key) {
            if(key == '2'){
                this.getPaper()
                this.reward='paper'
            }else if(key == '3'){
                this.getResearch()
                this.reward='researchProject'
            }else if(key == '4'){
                this.getPatent()
                this.reward='patent'
            }else if(key == '5'){
                this.getMonograph()
                this.reward='monograph'
            }else if(key == '6'){
                this.getFund()
                this.reward='fund'
            }else if(key == '7'){
                this.getReward()
                this.reward='reward'
            }else if(key == '8'){
                this.getAcademic()
                this.reward='academicExchange'
            }else if(key == '9'){
                this.getSocial()
                this.reward='socialInfluence'
            }  
        },
        info(id){
            getTeacher({teacherName:id}).then(res=>{
                this.baseInfo=res.data[0];
                this.departmentTree.forEach(e=>{
                    if(e.code == this.baseInfo.staffCategoryCode){
                        this.baseInfo.staffCategoryCode = e.name
                    }
                })
            })
        },
        onClickRowPaper(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangePaper([record.id])
                    }
                },
            }  
        },
        getPaper(){
            getPaper(this.doctorId).then(res=>{
                this.paperData = res.data
            })
        },
        onSelectChangePaper(selectedRowKeysPaper) {
            this.selectedRowKeysPaper = selectedRowKeysPaper;
        },
        //Social
        onClickRowSocial(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeSocial([record.id])
                    }
                },
            }  
        },
        getSocial(){
            getSocial(this.doctorId).then(res=>{
                this.socialData = res.data
            })
        },
        onSelectChangeSocial(selectedRowKeysSocial) {
            this.selectedRowKeysSocial = selectedRowKeysSocial;
        },
        //Reward
        onClickRowReward(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeReward([record.id])
                    }
                },
            }  
        },
        getReward(){
            getReward(this.doctorId).then(res=>{
                this.rewardData = res.data
            })
        },
        onSelectChangeReward(selectedRowKeysReward) {
            this.selectedRowKeysReward = selectedRowKeysReward;
        },
        //Academic
        onClickRowAcademic(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeAcademic([record.id])
                    }
                },
            }  
        },
        getAcademic(){
            getAcademic(this.doctorId).then(res=>{
                this.academicData = res.data
            })
        },
        onSelectChangeAcademic(selectedRowKeysAcademic) {
            this.selectedRowKeysAcademic = selectedRowKeysAcademic;
        },
        //Fund
        onClickRowFund(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeFund([record.id])
                    }
                },
            }  
        },
        getFund(){
            getFund(this.doctorId).then(res=>{
                this.fundData = res.data
            })
        },
        onSelectChangeFund(selectedRowKeysFund) {
            this.selectedRowKeysFund = selectedRowKeysFund;
        },
        //Monograph
        onClickRowMonograph(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeMonograph([record.id])
                    }
                },
            }  
        },
        getMonograph(){
            getMonograph(this.doctorId).then(res=>{
                this.monographData = res.data
            })
        },
        onSelectChangeMonograph(selectedRowKeysMonograph) {
            this.selectedRowKeysMonograph = selectedRowKeysMonograph;
        },
        //Patent
        onClickRowPatent(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangePatent([record.id])
                    }
                },
            }  
        },
        getPatent(){
            getPatent(this.doctorId).then(res=>{
                this.patentData = res.data
            })
        },
        onSelectChangePatent(selectedRowKeysPatent) {
            this.selectedRowKeysPatent = selectedRowKeysPatent;
        },
        //Research
        onClickRowResearch(record,index){
            return {
                on: { // 事件
                    click: (event) => {
                        this.onSelectChangeResearch([record.id])
                    }
                },
            }  
        },
        getResearch(){
            getResearch(this.doctorId).then(res=>{
                this.researchData = res.data
            })
        },
        onSelectChangeResearch(selectedRowKeysResearch) {
            this.selectedRowKeysResearch = selectedRowKeysResearch;
        }
  },
};
</script>
<style scoped>
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .btn-box{
        text-align: center;
        padding-bottom: 2rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>